import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useReservationTimeSlots = (itemId: string | null) => {
  return useQuery({
    queryKey: ['reservation-time-slots', itemId],
    queryFn: async () => {
      console.log('🔍 [useReservationTimeSlots] ItemId:', itemId);
      
      if (!itemId) return { recurring: [], specific: [] };

      const { data, error } = await supabase
        .from('reservation_time_slots')
        .select('*')
        .eq('item_id', itemId)
        .eq('is_available', true)
        .order('day_of_week', { ascending: true, nullsFirst: false })
        .order('specific_date', { ascending: true, nullsFirst: false })
        .order('start_time');

      console.log('📊 [useReservationTimeSlots] Raw data from Supabase:', data);
      console.log('❌ [useReservationTimeSlots] Error:', error);

      if (error) throw error;
      
      const recurring = data?.filter(slot => slot.day_of_week !== null) || [];
      const specific = data?.filter(slot => slot.specific_date !== null) || [];
      
      console.log('🔄 [useReservationTimeSlots] Recurring slots:', recurring);
      console.log('📅 [useReservationTimeSlots] Specific slots:', specific);
      console.log('📋 [useReservationTimeSlots] All slots:', data);
      
      return { recurring, specific, all: data || [] };
    },
    enabled: !!itemId,
  });
};